import PatientBookingProvider from "./context/PatientBookingProvider";
import CalenderComponent from "./CalenderComponent";

function PatientBookingv1() {
  return (
    <PatientBookingProvider>
      <CalenderComponent />
    </PatientBookingProvider>
  );
}

export default PatientBookingv1;
